<div class="row input-control-container">
    <div class="col-3 flex-start-center input-col input-control-container">
        <div class="width-100p">
            <label for="phone">Phone</label>
            <app-input id="phone" placeholder="Enter phone number" theme="border" disabled="true"
                [value]="fleet?.contactMethods?.phone">
            </app-input>
        </div>
    </div>
    <div class="col-4 flex-start-center input-col input-control-container">
        <div class="width-100p">
            <label for="email">Email</label>
            <app-input id="email" placeholder="Enter email" theme="border" disabled="true"
                [value]="fleet?.contactMethods?.email">
            </app-input>
        </div>
    </div>
</div>
<div class="row input-control-container">
    <div class="col-7 flex-start-center input-col input-control-container">
        <div class="width-100p">
            <label for="address">Address</label>
            <app-input id="address" placeholder="Enter address" theme="border" disabled="true"
                [value]="fleet?.addLine1">
            </app-input>
        </div>
    </div>
    <div class="row col-5 flex-start-center input-col input-control-container pr-0">
        <div class="col-6 width-100p pr-2">
            <label for="state">State</label>
            <app-input id="state" placeholder="Enter state" theme="border" disabled="true" [value]="fleet?.state">

            </app-input>
        </div>
        <div class="col-6 width-100p pr-0">
            <label for="p-code">ZIP / Postal Code</label>
            <app-input id="p-code" placeholder="Enter zip/postal code" theme="border" disabled="true"
                [value]="fleet?.zip">
            </app-input>
        </div>
    </div>
</div>